import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchPageIfNeeded } from '../actions'
import { DEFAULT_PAGE } from '../reducers/pages'
import { Main, Full } from '../components/Content'
import FourOFour from './404'
import ReactHtmlParser from 'react-html-parser'

const options = {
    decodeEntities: true,
    transform,
}

function transform(node) {
    if (node.type === 'tag' && node.name === 'a' && node.attribs.class === 'internal') {
        const child = ( node.children[0].type === 'tag' && node.children[0].name === 'img') ? <img src={node.children[0].attribs.src} alt="" height={node.children[0].attribs.height} width={node.children[0].attribs.width}/> : node.children[0].data
        return <Link key={node} to={node.attribs.href}>{child}</Link>
    }
}

class Generic extends Component {
    componentWillMount() {
        const { fetchPageIfNeeded } = this.props
        fetchPageIfNeeded(this.props.match.params.id)
    }
    render() {
        const { page, loading } = this.props
        return (
            !loading && !page.id ?
            <FourOFour />
            :
            <Main>
                <Full>
                    <h1>{ ReactHtmlParser(page.title.rendered) }</h1>
                    <div>
                        { ReactHtmlParser(page.content.rendered, options) }
                    </div>
                </Full>
            </Main>
		)
    }
}

function mapStateToProps(state, ownProps) {
    const page = state.pages[ownProps.match.params.id] || state.pages[DEFAULT_PAGE]
    const loading = state.loader.loadingPages
    return {
        page: page,
        loading: loading,
    }
}

export default connect(mapStateToProps,{ fetchPageIfNeeded })(Generic)


// WEBPACK FOOTER //
// ./src/pages/Generic.js